// extracted by mini-css-extract-plugin
export default {"container":"DialogContent_container__Tjwwl"};